<template>
<div class="row mT-15 fsz-xs" v-if="total">
    <div class="col-md-5 as-c pX-0">
        <div v-if="$route.name === 'goodsList' || $route.name === 'reportsSlowMoving'">
            {{$Lang('总商品数')}}：<span class="c-red-700">{{ countData.total }}</span>&nbsp;&nbsp;
            {{$Lang('总库存')}}：<span class="c-red-700">{{ countData.stockSum }}</span>&nbsp;&nbsp;
            {{$Lang('总成本价')}}：<span class="c-red-700" v-moneyFormat="countData.costPriceSum"></span>&nbsp;&nbsp;
            {{$Lang('总售价')}}：<span class="c-red-700" v-moneyFormat="countData.priceSum"></span>
        </div>
        <div v-else-if="$route.name === 'orderlist'">
            {{$Lang('总订单数')}}：<span class="c-red-700">{{ countData.total }}</span>&nbsp;&nbsp;
            {{$Lang('销售金额')}}：<span class="c-red-700" v-moneyFormat="countData.sales_amount"></span>&nbsp;&nbsp;
            {{$Lang('利润')}}：<span class="c-red-700" v-moneyFormat="countData.profit"></span>&nbsp;&nbsp;
            {{$Lang('销售商品')}}：<span class="c-red-700">{{ countData.goods_num }}</span>&nbsp;&nbsp;
        </div>
        <div v-else-if="$route.name === 'reportsGoodsStats'">
            {{$Lang('总记录数')}}：<span class="c-red-700">{{ countData.total }}</span>&nbsp;&nbsp;
            {{$Lang('销售金额')}}：<span class="c-red-700" v-moneyFormat="countData.sales_amount"></span>&nbsp;&nbsp;
            {{$Lang('利润')}}：<span class="c-red-700" v-moneyFormat="countData.profit"></span>&nbsp;&nbsp;
            {{$Lang('销售商品')}}：<span class="c-red-700">{{ countData.goods_num}}</span>&nbsp;&nbsp;
        </div>
        <div v-else-if="$route.name === 'reportsGoodsDiscart'">
            {{$Lang('总记录数')}}：<span class="c-red-700">{{ countData.total }}</span>&nbsp;&nbsp;
            {{$Lang('总售价')}}：<span class="c-red-700" v-moneyFormat="countData.sum_price"></span>&nbsp;&nbsp;
            {{$Lang('总成本')}}：<span class="c-red-700" v-moneyFormat="countData.sum_cost_price"></span>&nbsp;&nbsp;
            {{$Lang('商品总数')}}：<span class="c-red-700">{{ countData.goods_num}}</span>&nbsp;&nbsp;
        </div>
        <div v-else-if="$route.name === 'reportsCashInOut'">
            {{$Lang('总记录数')}}：<span class="c-red-700">{{ countData.total }}</span>&nbsp;&nbsp;
            {{$Lang('收入总额')}}：<span class="c-red-700" v-moneyFormat="countData.sum_cashIn"></span>&nbsp;&nbsp;
            {{$Lang('支出总额')}}：<span class="c-red-700" v-moneyFormat="countData.sum_cashOut"></span>&nbsp;&nbsp;
        </div>
        <div v-else-if="$route.name === 'memberList'" class="dataTables_info" id="datatable_info" role="status" aria-live="polite">{{$Lang('共')}} <span class="c-red-700">{{ countData.total }}</span> {{$Lang('会员')}}, {{$Lang('会员总余额')}}：<span class="c-red-700"  v-moneyFormat="countData.depositSum"></span>, {{$Lang('会员总积分')}}：<span class="c-red-700">{{ countData.pointSum }}</span></div>
       <div v-else class="dataTables_info" id="datatable_info" role="status" aria-live="polite">{{$Lang('共')}} <span class="c-red-700">{{ total }}</span> {{$Lang('条记录')}}</div>
    </div>
    <div class="col-md-7" v-if="Number(pagesize) > 1">
    <nav>
	    <ul class="pagination justify-content-end">
	        <li class="page-item" :class="{disabled: currentPage == 1}" @click="handleClick(currentPage - 1)">
	    	    <a class="page-link" tabindex="-1">{{$Lang('上一页')}}</a>
	        </li>
	        <li class="page-item" @click="handleClick(1)" :class="{active: currentPage == 1}"><a href="javascript:;" class="page-link">1</a></li>
	        <li class="page-item" v-for="item in pageList" :key="item" :index="item" @click="handleClick(item)" :class="{active: currentPage == item}"><a class="page-link" href="javascript:;">{{ item }}</a></li>
	        <li class="page-item pL-10 pR-10"  v-if="pagesize > 9 && pagesize - currentPage >= 6">....</li>
	        <li class="page-item" v-if="pagesize > 1" @click="handleClick(pagesize)" :class="{active: currentPage == pagesize}"><a href="javascript:;" class="page-link">{{ pagesize }}</a></li>
	        <li class="page-item" :class="{disabled: currentPage == pagesize}">
	    	    <a class="page-link" href="javascript:;" @click="handleClick(currentPage + 1)">{{$Lang('下一页')}}</a>  
	        </li>
   	    </ul>
    </nav>
    </div>
</div>
</template>
<script>
export default {
	name: 'pagination',
	props: {
		total: {
			type: Number,
			default: 1,
			required: true
		},
        countData: {
			type: Object
        },
		rowNumber: {
			type: Number
		},
		current: {
			type: Number,
			default: 1
		}
	},
	mounted () {
		this.init()
	},
	methods: {
		init () {
			this.currentPage = this.current
			this.pageRowNumber = this.rowNumber || this.CONFIG.PAGE_MAX_ROW

			this.pagesize = Math.ceil(this.total / this.pageRowNumber)
			this.pageList = this.calcPageList(this.currentPage)
		},
		calcPageList (current) {
			let pageList = []
		    if (this.pagesize > 9) {
		    	let left = Math.max(2, current - 3)
		        let right = Math.min(current + 3, this.pagesize - 1)
		        if (current - 1 < 3) {
		          	right = 7
		        }

		        if (this.pagesize - current < 3) {
		          	left = this.pagesize - 6
		        }

		        for (let i = left; i <= right; i++) {
		          	pageList.push(i)
		        }
		    } else {
		        for (let i = 2; i < this.pagesize; i++) {
		          	pageList.push(i)
		        }
		    }

		    return pageList
		},
		handleClick (number) {
			if (number < 1 || number > this.pagesize) {
				return
			}
			this.currentPage = number

			let limit = {
				skip: (number - 1) * this.pageRowNumber,
				take: this.pageRowNumber
			}
			this.$emit('pageChange', limit)
		}
	},
	data () {
		return {
			pageList: [],
			pagesize: 1,
			currentPage: 1,
			pageRowNumber: 20
		}
	},
	watch: {
		currentPage (val) {
			this.pageList = this.calcPageList(val)
		},
		total (val) {
			this.init()
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/pagination/pagination.vue